"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconAmmonia = function IconAmmonia(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M27 6.308a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2 0a5 5 0 0 1-4 4.9v4.155a9 9 0 0 1 7.243 12.561l3.611 2.085a5.002 5.002 0 0 1 8.074 5.816 5 5 0 0 1-9.074-4.084l-3.614-2.087A8.99 8.99 0 0 1 24 33.308a8.99 8.99 0 0 1-7.241-3.654l-3.614 2.087a5.002 5.002 0 0 1-9.073 4.084 5 5 0 0 1 8.073-5.816l3.61-2.085A9.001 9.001 0 0 1 23 15.363v-4.155a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 5 5m2 18a7 7 0 1 1-14 0 7 7 0 0 1 14 0M9.901 35.923a3 3 0 1 0-3-5.196 3 3 0 0 0 3 5.196m28.196 0a3 3 0 1 1 3-5.196 3 3 0 0 1-3 5.196M23.499 19.987c2.224 0 4.5 1.776 4.5 5h1c0-3.777-2.723-6-5.5-6z",
    clipRule: "evenodd"
  })));
};

export { IconAmmonia, IconAmmonia as default };
